import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';


const edit = {
	GarSzbKoef: null as number | null,
	GarSzbNapo: null as number | null,
	HodSzbKoef: null as number | null,
	HodSzbNapo: null as number | null,
	ProduktPrpt: null as boolean | null,
	ProvozovnaId: null as number | null,
	SntzapocPrp: null as boolean | null,
	StrednaklOzn: null as number | null,
	StrnakltypOzn: null as number | null,
	Text: null as string | null,
	TpzapocPrp: null as boolean | null,
	UkazatelPrpt: null as boolean | null,
	VyrazenPrp: null as boolean | null,
	VyrobekvozOzn: null as string | null,
	ZaznamId: null as number | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		StrnakltypOzn: [],
		VyrobekvozOzn: [],
		ProvozovnaId: [],
	},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
